import Types from '../constants/groups';
import { reloadTable } from './AsyncTable';
import { closeRequestModal, openRequestModal } from './modals';

import i18next from 'i18next';
import SCHEMAS from '../constants/modalSchemas';
import CitiesService from '../services/cities.service';
import GroupsService from '../services/groups.service';
import PromoGroupsService from '../services/promoGroups.service';
import UsersService from '../services/users.service';
import { resolveHasStudents } from '../utils/groupStudents';
import { getError, getErrorNotification, getInfo } from './toast';

function updateEqualizerState(data) {
    return async (dispatch, getState) => {
        const { single } = getState().groups;
        await editGroup({ ...single, ...data }, true)(dispatch, getState);
        setTimeout(() => {
            getSingleGroup(single.id)(dispatch, getState);
        }, 300);
    };
}

function getOfficeGroups(data) {
    return async dispatch => {
        dispatch({
            type: Types.GROUPS,
            groups: {
                loading: true,
            },
        });
        const res = await GroupsService.GetGroupsByFilters(data);
        if (res) {
            dispatch({
                type: Types.GROUPS,
                groups: {
                    officeGroups: res.payload.groups,
                    loading: false,
                },
            });
        }
    };
}

function setLastTopic(item) {
    return dispatch => {
        dispatch({
            type: Types.GROUPS,
            groups: {
                lastTopic: item,
            },
        });
    };
}

function setExitBool(item) {
    return dispatch => {
        dispatch({
            type: Types.GROUPS,
            groups: {
                acceptExitHwChange: item,
            },
        });
    };
}

function clearOfficeGroups() {
    return dispatch => {
        dispatch({
            type: Types.GROUPS,
            groups: {
                officeGroups: null,
                loading: false,
            },
        });
    };
}

function getGroupsHistory(...args) {
    return async () => {
        try {
            return await GroupsService.getGroupHistory(...args);
        } catch (e) {
            getError(e);
        }
    };
}

function getGroupHistoryHw(...args) {
    return async () => {
        try {
            return await GroupsService.getGroupHistoryHw(...args);
            // return await homework_V2Service.getGroupHistoryHwNew(...args);
        } catch (e) {
            getError(e);
        }
    };
}

function getGroups(...args) {
    return async dispatch => {
        try {
            const response = await GroupsService.GroupsList(...args);
            dispatch({
                type: Types.GROUPS,
                groups: {
                    ...response,
                },
            });
        } catch (e) {
            getError(e);
        }
    };
}

function getStudentsFromGroup(...args) {
    return async () => {
        try {
            return await GroupsService.getPupilsOfGroups(...args);
        } catch (e) {
            getError(e);
        }
    };
}

function initGroupHw(...args) {
    return async (dispatch, getState) => {
        const time = parseInt(args[0].time);
        if (time < 0 || time < 100) return getError('Invalid data passed');
        try {
            await GroupsService.InitGroupHW(...args);
            closeRequestModal()(dispatch, getState);
            await reloadTable()(dispatch, getState);
        } catch (e) {
            getError(e);
        }
    };
}

async function newEqResetHw(args) {
    return await GroupsService.InitGroupHW(args);
}

function getTeachersFromSelect() {
    return async function (dispatch, getState) {
        try {
            const { user } = getState();
            const info = user.emulation.length ? user.emulation[user.emulation.length - 1].info : user.info;
            // Match the API hierarchy using the same active profile as the request token.
            if (![1, 2, 3, 10].includes(Number(info.role_id))) {
                clearTeacherGroups()(dispatch);
                return;
            }

            const response = await UsersService.UsersList(false, {
                role_id: 4,
                size: 9999,
            });

            if (!response) return;
            dispatch({
                type: Types.GROUPS,
                groups: {
                    teacher_select: {
                        teacher: response.payload.list.sort((a, b) => (a.last_name > b.last_name ? 1 : -1)),
                    },
                },
            });
            return response;
        } catch (e) {
            console.log(e);
        }
    };
}

function getTeachersForSupport() {
    return async function (dispatch, getState) {
        try {
            const response = await UsersService.UsersList(false, {
                role_id: 4,
                size: 9999,
            });

            if (!response) return;
            dispatch({
                type: Types.GROUPS,
                groups: {
                    teacher_select: {
                        teacher: response.payload.list.sort((a, b) => (a.last_name > b.last_name ? 1 : -1)),
                    },
                },
            });
            return response;
        } catch (e) {
            console.log(e);
        }
    };
}

function clearTeacherGroups() {
    return async function (dispatch) {
        try {
            dispatch({
                type: Types.GROUPS,
                groups: {
                    teacher_select: {
                        teacher: null,
                    },
                },
            });
        } catch (e) {
            console.log(e);
        }
    };
}

function getPromoTags() {
    return async dispatch => {
        try {
            const res = await PromoGroupsService.GetTags();
            dispatch({
                type: Types.GROUPS,
                groups: {
                    promoTags: (res && res.payload) || [],
                },
            });
        } catch (e) {
            getError(e);
        }
    };
}

function getGroupsFromSelect(...args) {
    return async function (dispatch) {
        try {
            delete args.id;
            const res = await GroupsService.GroupsList(...args);
            if (!res) return;
            const response = res.payload.list.filter(el => el.id !== args.id);
            dispatch({
                type: Types.GROUPS,
                groups: {
                    select: {
                        list: response,
                    },
                },
            });
            return response;
        } catch (e) {
            console.log(e);
        }
    };
}

function addGroup(...args) {
    return async (dispatch, getState) => {
        try {
            let data = JSON.parse(JSON.stringify(args[0]));
            const courseType = +data.course_type;

            if (![3, 5].includes(courseType)) {
                delete data.lesson_time_add;
                delete data.lesson_day_add;
            }
            await GroupsService.AddGroup(data);
            await reloadTable()(dispatch, getState);
        } catch (error) {
            getError(error);
            return;
        }
        closeRequestModal()(dispatch, getState);
    };
}

function editGroup(fields, no_reload = false) {
    return async (dispatch, getState) => {
        const args = JSON.parse(JSON.stringify(fields));
        const group = await getSingleGroup(args.id)(dispatch);
        const res = await GroupsService.getPupilsOfGroups(
            false,
            {
                page: 0,
                size: 9999,
            },
            { group_id: args.id }
        );
        const hasStudents = resolveHasStudents(res);
        const list = res?.list || res?.payload?.list || [];
        const isCandidate = list.some(student => +student.status === 6);

        if (+group.price === +args.price) {
            delete args.price;
        }
        if (args.price) {
            args.price = Number(args.price);
        }
        args.school_id = +args.geo_school_id;

        const targetCourseType = args.course_type ?? group.course_type;
        const wasPromoGroup = String(group.course_type) === '2';
        const isPromoTarget = String(targetCourseType) === '2';

        const toDay = value => {
            if (!value) return null;
            const date = new Date(value);
            return Number.isNaN(date.getTime()) ? null : date.toISOString().slice(0, 10);
        };
        const startDateSubmitted = Object.prototype.hasOwnProperty.call(args, 'course_start_date');
        const startDateChanged = startDateSubmitted && toDay(group.course_start_date) !== toDay(args.course_start_date);

        const refusalText = key => i18next.t(hasStudents === null ? 'error.promoMembershipUnknown' : key);

        if (wasPromoGroup && startDateChanged && hasStudents !== false) {
            getErrorNotification(refusalText('error.promoGroupDateChangeNotEmpty'));
            return;
        }

        if (wasPromoGroup !== isPromoTarget && hasStudents !== false) {
            getErrorNotification(
                refusalText(isPromoTarget ? 'error.promoGroupNotEmpty' : 'error.promoGroupTypeChangeNotEmpty')
            );
            return;
        }

        if (group.course_type !== '3' && args.course_type === '3') {
            closeRequestModal()(dispatch, getState);
            setTimeout(() => {
                openRequestModal({
                    opened: true,
                    data: {
                        header: i18next.t('HWSettings.remove_hw'),
                        modaltype: 'removeHWModal',
                        course_id: args.id,
                        isChangeToLi: true,
                        updateGroupData: args,
                    },
                })(dispatch, getState);
            }, 200);
            return;
        }
        if (group.course_type === '1' && !isCandidate && args.course_type === '0') {
            getError({
                message:
                    'You cannot change the course type because there are no students with candidate status in the group.',
            });
            return;
        }
        if (group.course_type === '1' && args.course_type === '0') {
            getInfo(i18next.t('modals.autoStartDateChanged'));
            closeRequestModal()(dispatch, getState);
            setTimeout(() => {
                openRequestModal({
                    opened: true,
                    data: {
                        groupToSave: args,
                        schema: SCHEMAS.groupActivationModal,
                        header: i18next.t('groups.group_activation'),
                        modaltype: 'GroupActivationModal',
                    },
                })(dispatch, getState);
            }, 200);
            return;
        }
        // closeRequestModal()(dispatch, getState);
        try {
            const res = await GroupsService.EditGroup(args);
            closeRequestModal()(dispatch, getState);
            dispatch({ type: Types.SET_PRICE_ERROR, payload: null });
        } catch (error) {
            console.log(error);
            getError(error);

            // Якщо помилка містить "Incorrect price", оновлюємо стан
            if (error.message.includes('Incorrect price')) {
                dispatch({
                    type: Types.SET_PRICE_ERROR,
                    payload: 'Incorrect price',
                });
            }
        }
        if (!no_reload) reloadTable()(dispatch, getState);
    };
}

function getSingleGroup(args) {
    return async dispatch => {
        const res = await GroupsService.SingleGroup(false, { course_id: args });
        dispatch({
            type: Types.GROUPS,
            groups: {
                single: {
                    ...res,
                },
            },
        });
        return res;
    };
}

function clearSingleGroup() {
    return async dispatch => {
        dispatch({
            type: Types.GROUPS,
            groups: {
                single: null,
            },
        });
    };
}

function deleteGroup(...args) {
    return (dispatch, getState) => {
        closeRequestModal()(dispatch, getState);
        GroupsService.DeleteGroup(...args).then(response => {
            dispatch({
                type: Types.DELETEGROUP,
            });
            if (response) {
                reloadTable()(dispatch, getState);
            }
        });
    };
}

function getListToPlate(...args) {
    return dispatch => {
        CitiesService.CitiesList(...args).then(response => {
            dispatch({
                type: Types.PLATELIST,
                cities: {
                    list: response.list,
                },
            });
        });
    };
}

function filterData(filter_data) {
    return dispatch => {
        dispatch({
            type: Types.FILTRATION,
            groups: {
                filtration: {
                    ...groups.filtration,
                    teacher: filter_data.teacher || null,
                    city: filter_data.city || null,
                    office: filter_data.office || null,
                },
            },
        });
    };
}

export {
    addGroup,
    clearOfficeGroups,
    clearSingleGroup,
    clearTeacherGroups,
    deleteGroup,
    editGroup,
    filterData,
    getGroupHistoryHw,
    getGroups,
    getGroupsFromSelect,
    getGroupsHistory,
    getListToPlate,
    getOfficeGroups,
    getPromoTags,
    getSingleGroup,
    getStudentsFromGroup,
    getTeachersForSupport,
    getTeachersFromSelect,
    initGroupHw,
    newEqResetHw,
    setExitBool,
    setLastTopic,
    updateEqualizerState
};
